import { Injector } from "@angular/core";
import { AutoUploadNode } from "../../AutoUploadNode";
import { AutoUploadEntityEnum } from "../../../AutoUploadEntityEnum";
import { ServiceEnum } from "../../../ServiceEnum";
import { BaseNode } from "../../BaseNode";
import { TreeNodeSubstancesList } from "../../Art57Node/ListEntity/TreeNodeSubstancesList";
import { ApprovedSubstanceEntity } from "../../../Data/MedicinalProductData/ApprovedSubstanceEntity";
import { SourceAutoUploadEntity } from "./SourceAutoUploadEntity";
import { TreeNodeMedicinalProductsSubstanceTranslation } from "../ListEntity/TreeNodeMedicinalProductsSubstanceTranslation";
import { TreeNodeMedicinalProductsSubstanceAlias } from "../ListEntity/TreeNodeMedicinalProductsSubstanceAlias";
import { TreeNodeMedicinalProductsSubstancePreviousEvCode } from "../ListEntity/TreeNodeMedicinalProductsSubstancePreviousEvCode";
import { TreeNodeSubstancePreviousEvCode } from "./TreeNodeSubstancePreviousEvCode";
import { TreeNodeMedicinalProductsSubstanceInternationalCode } from "../ListEntity/TreeNodeMedicinalProductsSubstanceInternationalCode";
import { TreeNodeMedicinalProductsAttachments } from "../ListEntity/TreeNodeMedicinalProductsAttachments";
import { TreeNodeMedicinalProductsSubstanceParentCode } from "../ListEntity/TreeNodeMedicinalProductsSubstanceParentCode";
import { environment } from "../../../../../../environments/environment";
import { LookupGetService } from "../../../../service/lookup-service/lookup-get.service";


export class ApprovedSubstanceAutoUploadEntity extends AutoUploadNode {
    useHist: boolean = false;
    constructor(injector: Injector, labelTemplate: string, parent: BaseNode, model: any, useHist: boolean, disableAutoUpload:boolean, cloningNode: boolean) {
        super(injector, 
            labelTemplate, 
            ApprovedSubstanceEntity, 
            useHist ? AutoUploadEntityEnum.approvedSubstanceHist : AutoUploadEntityEnum.approvedSubstance, 
            ServiceEnum.MedicinalProducts, 
            parent, 
            model, 
            TreeNodeSubstancesList, 
            true, 
            disableAutoUpload,
            cloningNode,
            { nodeTypeToCreateName: 'addApprovedSubstance' });
            this.labelNodeName = 'Approved Substance';
            this.useHist = useHist;
    }

    override postLoadEntity(model: any): void {
        
        if (model.source) {
            this.children?.push(new SourceAutoUploadEntity(this.ioc!, model.source.ev_Code + " - " + model.source.sourcename, this, model.source, false,this.disableAutoUpload, this.cloningNode));
        }
        
        if (!(this.parent instanceof TreeNodeSubstancePreviousEvCode)) {
            this.children?.push(new TreeNodeMedicinalProductsSubstanceTranslation(this.ioc!, this, false, model.substancetranslations?model.substancetranslations.substancetranslation:[]));
            this.children?.push(new TreeNodeMedicinalProductsSubstanceAlias(this.ioc!, this, false, model.substancealiases?model.substancealiases.substancealias:[]));
            this.children?.push(new TreeNodeMedicinalProductsSubstanceInternationalCode(this.ioc!, this, false,  model.internationalcodesonly?model.internationalcodesonly.internationalcode:[]));
            this.children?.push(new TreeNodeMedicinalProductsSubstanceParentCode(this.ioc!,this, false, model.parentcodesonly?model.parentcodesonly.internationalcode:[]));
            this.children?.push(new TreeNodeMedicinalProductsSubstancePreviousEvCode(this.ioc!,this, false, model.previousevcodes?model.previousevcodes.previousevcode:[]));
            this.children?.push(new TreeNodeMedicinalProductsAttachments(this.ioc!,'Substance',this, false, model.substanceattachments?model.substanceattachments.substanceattachment:[]));            
        }   
    }

    override cloneNode(newParent: BaseNode): BaseNode|undefined {
      let clonedNode: ApprovedSubstanceAutoUploadEntity = new ApprovedSubstanceAutoUploadEntity(this.ioc!, this.labelTemplate,newParent,this.datasource,this.useHist,false, true);      
//      clonedNode.disableAutoUpload = false;  
      clonedNode.loadEntity();
      clonedNode.isLoading = false;

      clonedNode.data.model = JSON.parse(JSON.stringify(this.data.model));
  
      clonedNode.refreshLabel();  
      clonedNode.expanded = this.expanded && (environment.userPreferences.autoexpandNodesOnCloning ||environment.userPreferences.alwaysAutoexpandNodes)

      if (!this.children || this.children.length===1) { // check if dummy node
   // not using disableAutoupload    clonedNode.postLoadEntity(this.datasource);
        clonedNode.cloningNode = false;
        return clonedNode; 
      }
  
      this.children?.forEach((child) => {
        let childToClone = child as BaseNode;
        let clonedChildren = childToClone.cloneNode(clonedNode);
        if (clonedChildren) {
            clonedNode.children?.push(clonedChildren);
            clonedChildren.refreshLabel();
        }
      });
  
      clonedNode.cloningNode = false;
      return clonedNode;
    }

}